"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.failEvent = exports.completeEvent = exports.startEvent = void 0;
var startEvent = function (event) {
    return event + "Started";
};
exports.startEvent = startEvent;
var completeEvent = function (event) {
    return event + "Completed";
};
exports.completeEvent = completeEvent;
var failEvent = function (event) {
    return event + "Failed";
};
exports.failEvent = failEvent;
//# sourceMappingURL=EventMarker.js.map